import { useNavigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import { useEffect, useState } from "react";
import { fetchUsers } from "services/data";
import { createEmployeePerformaceReport, fetchWatomsRelatedVtcs } from "services/watoms/watomsData";
import toast from "react-hot-toast";

const WatomsPMSPerformanceReport = () => {
    const { userInfo } = useAuth();
    const navigate = useNavigate();
    const [unfilteredUsers, setUnfilteredUsers] = useState([]);
    const [users, setUsers] = useState([]);
    const [vtcs, setVtcs] = useState([]);
    const [selectedVtc, setSelectedVtc] = useState('');
    const [form, setForm] = useState({
        plannedDays: "",
        attendedDays: "",
        absenceDays: "",
        lateCount: "",
        earlyLeaveCount: "",
        note: "",
        user_id: "",
        tasks: [""],
        ratings: {
            cooperation: 0,
            discipline: 0,
            initiative: 0,
            problemSolving: 0,
            timeManagement: 0,
            communication: 0,
        }
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        const loadUsers = async () => {
            const response = await fetchUsers(userInfo);
            let filteredUsers;
            if (userInfo?.organization_id === 13 && userInfo?.code !== 1523 && userInfo?.code !== 1524) {
                filteredUsers = response;
            } else if (userInfo?.code === 1523) {
                filteredUsers = response.filter(user => user.employee.organization_id === 7);
            } else if (userInfo?.code === 1524) {
                filteredUsers = response.filter(user => user.employee.organization_id === 8);
            } else if (userInfo?.user_role === "Manager") {
                filteredUsers = response.filter(user => user.employee.organization_id === Number(userInfo.organization_id));
            }
            setUnfilteredUsers(filteredUsers);
            setUsers(filteredUsers);
        }

        const loadVtcs = async () => {
            const response = await fetchWatomsRelatedVtcs(userInfo);
            setVtcs(response)
        }

        loadUsers();
        loadVtcs();
    }, [userInfo])

    useEffect(() => {
        const filterUsers = () => {
            let filtering;
            if (selectedVtc === "") {
                filtering = unfilteredUsers;
            } else {
                filtering = unfilteredUsers.filter(user => user.employee.organization_id === Number(selectedVtc));
            }
            setUsers(filtering);
        }

        filterUsers();
    }, [selectedVtc, unfilteredUsers])

    const handleChange = (field, value) => {
        setForm((prev) => ({ ...prev, [field]: value }));
    };

    const handleRating = (field, value) => {
        setForm((prev) => ({
            ...prev,
            ratings: { ...prev.ratings, [field]: value }
        }));
    };

    const addTask = () => {
        setForm((prev) => ({
            ...prev,
            tasks: [...prev.tasks, ""]
        }));
    };

    const updateTask = (index, value) => {
        setForm((prev) => {
            const updated = [...prev.tasks];
            updated[index] = value;
            return { ...prev, tasks: updated };
        });
    };

    const removeTask = (index) => {
        setForm((prev) => {
            const updated = prev.tasks.filter((_, i) => i !== index);
            return { ...prev, tasks: updated };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        let newErrors = {};

        // Required fields validation
        if (!form.plannedDays) {
            newErrors.plannedDays = "الرجاء ادخال عدد الأيام"
            toast.error("الرجاء ادخال عدد الأيام")
        };
        if (!form.attendedDays) {
            newErrors.attendedDays = "الرجاء ادخال الحضور"
            toast.error("الرجاء ادخال الحضور")
        };
        if (!form.absenceDays) {
            newErrors.absenceDays = "الرجاء ادخال الغياب"
            toast.error("الرجاء ادخال الغياب");
        };
        if (!form.lateCount) {
            newErrors.lateCount = "الرجاء ادخال التأخير"
            toast.error("الرجاء ادخال التأخير");
        };
        if (!form.earlyLeaveCount) {
            newErrors.earlyLeaveCount = "الرجاء ادخال الانصراف المبكر"
            toast.error("الرجاء ادخال الانصراف المبكر");
        };
        if (!form.user_id) {
            newErrors.user_id = "يرجى اختيار الموظف"
            toast.error("يرجى اختيار الموظف");
        };

        // ratings required
        const requiredRatings = {
            cooperation: "التعاون",
            discipline: "الانضباط",
            initiative: "المبادرة",
            problemSolving: "حل المشكلات",
            timeManagement: "ادارة الوقت",
            communication: "التواصل"
        };

        Object.keys(requiredRatings).forEach((key) => {
            if (form.ratings[key] === 0) {
                newErrors[key] = `يرجى اختيار تقييم لـ ${requiredRatings[key]}`;
            }
        });

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;

        // 🔥 Prepare request body for backend
        const payload = {
            user_id: Number(form.user_id),
            planned_working_days: Number(form.plannedDays),
            actual_working_days: Number(form.attendedDays),
            absence_days: Number(form.absenceDays),
            no_of_latness: Number(form.lateCount),
            no_of_early_leave: Number(form.earlyLeaveCount),
            notes: form.note,

            // Scores matching backend
            CooperationTeamwork: form.ratings.cooperation,
            AdherenceToInstructions: form.ratings.discipline,
            LevelOfInitiative: form.ratings.initiative,
            ProblemSolvingAbility: form.ratings.problemSolving,
            TimeManagementWorkOrganization: form.ratings.timeManagement,
            CommunicationSkills: form.ratings.communication,

            // tasks: remove empty tasks
            tasks: form.tasks.filter((t) => t.trim() !== "")
        };

        try {
            await createEmployeePerformaceReport(payload);

            toast.success("تم حفظ التقرير بنجاح!");
            navigate('/watoms')

        } catch (error) {
            alert("حدث خطأ أثناء حفظ التقرير");
            console.error(error);
        }
    };

    const ratingFields = [
        { key: "cooperation", label: "التعاون والعمل الجماعي" },
        { key: "discipline", label: "الالتزام بالتعليمات" },
        { key: "initiative", label: "مستوى المبادرة" },
        { key: "problemSolving", label: "القدرة على حل المشكلات" },
        { key: "timeManagement", label: "إدارة الوقت وتنظيم العمل" },
        { key: "communication", label: "مهارات التواصل" },
    ];

    const numberInputs = [
        { key: "plannedDays", label: "ايام العمل المقررة" },
        { key: "attendedDays", label: "ايام الحضور الفعلي" },
        { key: "absenceDays", label: "عدد ايام الغياب" },
        { key: "lateCount", label: "عدد مرات التأخير" },
        { key: "earlyLeaveCount", label: "عدد مرات الانصراف المبكر" },
    ];

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 flex justify-center items-start py-10 px-4">

            {/* Container Card */}
            <form
                onSubmit={handleSubmit}
                className="w-full max-w-lg bg-white/80 backdrop-blur-lg shadow-2xl rounded-3xl p-6 md:p-8 border border-white/60 space-y-6"
                dir="rtl"
            >
                {/* Title */}
                <h1 className="text-3xl md:text-4xl font-extrabold text-center text-blue-900 mb-4 tracking-wide">
                    تقرير الأداء
                </h1>
                {userInfo?.organization_id === 13 && userInfo?.code !== 1523 && userInfo?.code !== 1524 && <div className="flex flex-col">
                    <label className="font-semibold text-gray-700 mb-1">اختر المركز</label>

                    <select
                        value={selectedVtc}
                        onChange={(e) => setSelectedVtc(e.target.value)}
                        className="w-full px-4 py-2 rounded-lg border border-gray-300 bg-white focus:ring-2 focus:ring-blue-500 outline-none"
                    >
                        <option value="">-- اختر المركز --</option>

                        {vtcs?.map((vtc) => (
                            <option key={vtc.id} value={vtc.id}>
                                {vtc?.name}
                            </option>
                        ))}
                    </select>

                    {errors.user_id && (
                        <p className="text-red-500 text-xs mt-1">{errors.user_id}</p>
                    )}
                </div>}
                <div className="flex flex-col">
                    <label className="font-semibold text-gray-700 mb-1">اختر الموظف</label>

                    <select
                        value={form["user_id"]}
                        onChange={(e) => handleChange("user_id", e.target.value)}
                        className="w-full px-4 py-2 rounded-lg border border-gray-300 bg-white focus:ring-2 focus:ring-blue-500 outline-none"
                    >
                        <option value="">-- اختر موظف --</option>

                        {users?.map((u) => (
                            <option key={u.id} value={u.id}>
                                {u.employee
                                    ? `${u.employee.employee_first_name} ${u.employee.employee_middle_name} ${u.employee.employee_last_name}`
                                    : "بدون اسم"}
                            </option>
                        ))}
                    </select>

                    {errors.user_id && (
                        <p className="text-red-500 text-xs mt-1">{errors.user_id}</p>
                    )}
                </div>
                {numberInputs.map(({ key, label }) => (
                    <div key={key} className="flex flex-col">
                        <label className="font-semibold text-gray-700 mb-1">{label}</label>
                        <input
                            type="number"
                            value={form[key]}
                            onChange={(e) => handleChange(key, e.target.value)}
                            placeholder="اكتب هنا..."
                            className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 outline-none"
                        />
                    </div>
                ))}

                <div className="flex flex-col">
                    <label className="font-semibold text-gray-700 mb-1">ملاحظة</label>
                    <input
                        type="text"
                        value={form.note}
                        onChange={(e) => handleChange("note", e.target.value)}
                        placeholder="اكتب ملاحظة..."
                        className="px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 
                        focus:ring-blue-500 outline-none"
                    />
                </div>

                <h2 className="text-xl font-bold text-blue-800 mt-6">
                    المهام الموكلة خلال الاسبوع
                </h2>

                {form.tasks.map((task, index) => (
                    <div key={index} className="flex items-center gap-3 mb-2">

                        <label className="font-medium text-gray-700 w-24">
                            {`المهمة ${index + 1}`}
                        </label>

                        {/* Task input */}
                        <input
                            type="text"
                            value={task}
                            onChange={(e) => updateTask(index, e.target.value)}
                            placeholder={`المهمة ${index + 1}`}
                            className="px-4 py-2 flex-1 rounded-lg border border-gray-300 focus:ring-2 
                            focus:ring-blue-500 outline-none"
                        />

                        {/* Remove button */}
                        {index > 0 && (
                            <button
                                type="button"
                                onClick={() => removeTask(index)}
                                className="w-10 h-10 flex items-center justify-center rounded-full 
                                bg-red-500 text-white hover:bg-red-600 transition"
                            >
                                ✕
                            </button>
                        )}
                    </div>
                ))}

                {/* Add Task Button */}
                <button
                    type="button"
                    onClick={addTask}
                    className="flex items-center justify-center gap-2 w-full py-2 mt-2 rounded-lg 
                    bg-green-600 text-white font-bold hover:bg-green-700 transition shadow"
                >
                    <span className="text-xl">+</span> إضافة مهمة جديدة
                </button>

                {ratingFields.map(({ key, label }) => (
                    <div key={key} className="flex flex-col mt-4">
                        <label className="font-semibold text-gray-700 mb-1">{label}</label>

                        <div className="flex gap-3">
                            {[1, 2, 3, 4, 5].map((num) => (
                                <button
                                    type="button"
                                    key={num}
                                    onClick={() => handleRating(key, num)}
                                    className={`w-10 h-10 rounded-full flex items-center justify-center border transition-all
                                        ${form.ratings[key] === num
                                            ? "bg-blue-600 text-white border-blue-700 scale-110 shadow"
                                            : "bg-gray-100 text-gray-700 border-gray-300 hover:bg-blue-100"
                                        }`}
                                >
                                    {num}
                                </button>
                            ))}
                        </div>

                        {errors[key] && (
                            <p className="text-red-500 text-xs mt-2">{errors[key]}</p>
                        )}
                    </div>
                ))}

                {/* =========================
                   SUBMIT BUTTON
                   ========================= */}
                <button
                    type="submit"
                    className="w-full py-3 bg-blue-700 text-white font-semibold rounded-xl 
                        shadow-md hover:bg-blue-800 transition mt-6 text-lg"
                >
                    حفظ التقرير
                </button>
            </form>
        </div>
    );
};

export default WatomsPMSPerformanceReport;